"use client";
import React, { useEffect, useState } from "react";
import { GoTriangleUp } from "react-icons/go";

const ScrollUpButton = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const checkScrollPosition = () => {
      if (window.scrollY > window.innerHeight * 1) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollPosition);

    return () => window.removeEventListener("scroll", checkScrollPosition);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return showButton ? (
    <div className="scroll-up-button" onClick={scrollToTop}>
      <div>
        <GoTriangleUp className="scroll-up-icon"/>
      </div>
    </div>
  ) : null;
};

export default ScrollUpButton;
